var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2.25C10.0148 2.25 8.00003 4.26472 8.00003 6.75C8.00003 9.23527 10.0148 11.25 12.5 11.25C14.9853 11.25 17 9.23527 17 6.75C17 4.26472 14.9853 2.25 12.5 2.25ZM9.50003 6.75C9.50003 5.09314 10.8432 3.75 12.5 3.75C14.1569 3.75 15.5 5.09314 15.5 6.75C15.5 8.40683 14.1569 9.75 12.5 9.75C10.8432 9.75 9.50003 8.40683 9.50003 6.75ZM12.5 12C9.04733 12 6.91271 13.074 5.66322 14.6122C4.43814 16.1202 4.17433 17.9419 4.17067 19.2354C4.16626 20.7895 5.51724 21.75 6.8691 21.75H18.131C19.4828 21.75 20.8338 20.7895 20.8294 19.2354C20.8257 17.9419 20.5619 16.1202 19.3369 14.6122C18.0874 13.074 15.9527 12 12.5 12ZM5.67066 19.2396C5.67385 18.1099 5.90964 16.6878 6.82748 15.5579C7.72092 14.4581 9.37253 13.5 12.5 13.5C15.6275 13.5 17.2792 14.4581 18.1726 15.5579C19.0904 16.6878 19.3262 18.1099 19.3294 19.2396C19.3309 19.7687 18.8622 20.25 18.131 20.25H6.8691C6.13784 20.25 5.66916 19.7687 5.67066 19.2396Z",
    fill: "#2D3036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/PersonIcon.02f0cf7ae109f32d2c3ef682714b88b7.svg";
export { ForwardRef as ReactComponent };